import { RadioGroup } from '@chakra-ui/react';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomFormControl } from '@/common/CustomFormControl/CustomFormControl';
import CustomFormFieldLabel from '@/common/CustomFormFieldLabel/CustomFormFieldLabel';
import CustomRadioButton from '@/common/CustomRadioButtonGroup/CustomRadioButton/CustomRadioButton';
import './CustomRadioButtonGroup.scss';

export interface CustomRadioButtonGroupProps {
  name: string;
  label: string;
  radioButtonOptions: string[];
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  showFormValueOnly?: boolean;
}

const CustomRadioButtonGroup = ({
  name,
  label,
  radioButtonOptions,
  isRequired = false,
  isDisabled = false,
  isReadOnly = false,
  showFormValueOnly = false,
}: CustomRadioButtonGroupProps) => {
  const { trigger } = useFormContext();

  return (
    <CustomFormControl
      componentName={'Custom Radio Button Group'}
      name={name}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      showFormValueOnly={showFormValueOnly}
    >
      <CustomFormFieldLabel
        label={label}
        isRequired={isRequired}
        isDisabled={isDisabled}
      />

      <Controller
        name={name}
        defaultValue={''}
        render={({ field }) => {
          return (
            <fieldset disabled={isDisabled || isReadOnly}>
              {/* use fieldset to disable radio buttons as setting input to disabled will result in an undefined form value */}
              <RadioGroup
                {...field}
                onChange={value => {
                  field.onChange(value); // Set the value in the form
                  trigger(name); // Manually trigger validation on change
                }}
                className={'custom-radio-group-container'}
              >
                {radioButtonOptions.map((option: any) => (
                  <CustomRadioButton
                    key={option}
                    label={option}
                    value={option}
                  />
                ))}
              </RadioGroup>
            </fieldset>
          );
        }}
      />
    </CustomFormControl>
  );
};

export default CustomRadioButtonGroup;
